/**
 * Query keys for the Sales Insights endpoints (/api/pc/insights). All are
 * GETs, fetched through useAuthenticatedQuery with the URL as the key; notes
 * also take a POST to the same URL.
 */

export const PC_INSIGHTS_QUERY_KEY = ["/api/pc/insights"] as const;

export const pcInsightsAccountQueryKey = (accountId: string) =>
  [`/api/pc/insights/accounts/${encodeURIComponent(accountId)}`] as const;

export const pcInsightsAccountNotesQueryKey = (accountId: string) =>
  [`/api/pc/insights/accounts/${encodeURIComponent(accountId)}/notes`] as const;
